import React, { useEffect, useState } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function RoomBookings() {
    const [allDharamsala, setAllDharamsala] = useState([])
    const [inpType,setInpType] = useState('text')
    const navigate = useNavigate()
    const handleFocus = ()=>{
        setInpType('date')
    }

   const handleBlur = ()=>{
    setInpType('text')
   }
    useEffect(() => {
        async function getData() {
            try {
                let response = await axios.get('https://api.padampura.com/All_Dharmshalas')
                setAllDharamsala(response.data.data)
            } catch (error) {
                console.error('Error in RoomBooking at get Dharamsala')
            }
        }
        getData()
    }, [])
    return (
        <div className='container' style={{ marginTop: '5rem' }}>

            {/* Room checking */}
            <div>
                <form>
                    <div className='container'>
                        <p className='text-center fs-2 fw-semibold'>Check <span className='text-decoration-underline'>Available</span> Room</p> 

                        <hr/>
                        <div className='d-flex gap-2 justify-content-center align-item-center flex-wrap'>
                            <div className='col-6 col-md-2'>
                                <input type={inpType} placeholder='Select Date' className='form-control' onFocus={handleFocus} onBlur={handleBlur}/>
                            </div>
                                <input type='submit' value={'Check'} className='btn btn-sm btn-outline-success'/>
                        </div>
                    </div>
                </form>
            </div>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <div className='d-flex flex-column'>
                                    <span>Dharamsala</span>
                                </div>
                            </TableCell>
                            <TableCell align="right">Room Price</TableCell>
                            <TableCell align="right">
                                <div>
                                   <span>Room</span> 
                                   <span>Available</span> 
                                </div>
                            </TableCell>
                            <TableCell align="right">Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {allDharamsala.map((row) => (
                            <TableRow
                                key={row.name}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">
                                    {row.dhrm_name}
                                </TableCell>
                                <TableCell align='right'>500 - 1000</TableCell>
                                {/* <TableCell align="right">{10}</TableCell> */}
                                <TableCell align="right">
                                    <div className='d-flex gap-2 flex-wrap justify-content-end text-end'>
                                    <span>{"Ac-30"}</span>
                                    <span>{"Non AC-50"}</span>
                                    </div>
                                    </TableCell>
                                <TableCell align="right">
                                    <button className='btn btn-sm btn-outline-danger' onClick={()=>{navigate(`/DharmshalaDetail/${row.dhrm_id}`)}}>Book</button>
                                </TableCell>
                                
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}

export default RoomBookings
